import { UserModel } from "./user.model";


export class CreateUserInfoModel {
    user: UserModel = new UserModel();
    inviteCode: string = "";
}
